import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';

import { DSComponents, DesignSystemHelperService } from '@frontend/promo-utils';
import { DsButtonIcon } from '@frontend/ui/button-icon';
import { DsCard } from '@frontend/ui/card';
import { DsTooltipModule } from '@frontend/ui/tooltip';
import { DynamicHtmlDirective } from '@frontend/vanilla/core';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { BaseDetailsContent, BaseDetailsDataPoint } from '../base-details.model';

@Component({
    selector: 'details-meta-data',
    templateUrl: 'details-meta-data.component.html',
    styleUrls: ['./details-meta-data.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, DynamicHtmlDirective, DsCard, NgTemplateOutlet, DsTooltipModule, IconCustomComponent, DsButtonIcon],
})
export class DetailsMetaDataComponent implements OnChanges {
    @Input()
    metaDataList: BaseDetailsDataPoint[];
    @Input()
    detailsContent: BaseDetailsContent;
    @Input()
    bonusExcludeGamesIndex: number;
    @Input() public dsHighlight: boolean = true;
    @Input() public isStaticPromotion: boolean;
    filteredMetaDataList: BaseDetailsDataPoint[];
    dsComponents: DSComponents;

    constructor(private designSystemHelperService: DesignSystemHelperService) {
        this.dsComponents = this.designSystemHelperService.getDsComponentsList();
    }

    ngOnChanges() {
        this.filteredMetaDataList = this.metaDataList?.filter((datapoint) => datapoint.title && datapoint.description);
    }
}
